import Image from "next/image";
import React from "react";

export interface SubCardIconsProps {
  level: "AFL" | "NRL" | "BBL" | "Full";
}
export type SubcardItem = string[];

export interface SubCards {
  [key: string]: SubcardItem[];
}

const subCardIcons = {
  NRL: [
    ["/images/nrl.svg", "nrl"],
    ["/images/discord.svg", "discord"],
  ],
  BBL: [
    ["/images/bbl.svg", "bbl"],
    ["/images/discord.svg", "discord"],
  ],
  CRICKET: [
    ["/images/bbl.svg", "bbl"],
    ["/images/discord.svg", "discord"],
  ],
  Full: [
    ["/images/nrl.svg", "nrl"],
    ["/images/afl.svg", "afl"],
    ["/images/bbl.svg", "bbl"],
    ["/images/nfl.svg", "nfl"],
    ["/images/premierleague.svg", "epl"],
    ["/images/nba.svg", "nba"],
    ["/images/discord.svg", "discord"],
  ],
  SCPB: [
    ["/images/nrl.svg", "nrl"],
    ["/images/afl.svg", "afl"],
    ["/images/bbl.svg", "bbl"],
    ["/images/nfl.svg", "nfl"],
    ["/images/premierleague.svg", "epl"],
    ["/images/nba.svg", "nba"],
    ["/images/discord.svg", "discord"],
  ],
};

const SubCardIcons = ({ level }: SubCardIconsProps) => {
  return (
    <div className="grid grid-cols-3 grid-rows-2 md:flex flex-row align-center mx-auto gap-6">
      {//@ts-ignore
      subCardIcons[level]?.map(function (item: SubcardItem) {
        return (
          <div
            className={"bg-transparent flex items-center justify-center"}
            key={`${level}-${item[1]}`}
          >
            <div className={`relative ${item[1]} card-icon`}>
              <Image
                src={item[0]}
                color="green"
                alt={`access to ${level} content`}
                fill
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SubCardIcons;
